// extracted by mini-css-extract-plugin
export var actionButton = "_ya-2";
export var card = "_ya-0";
export var disambiguationList = "_ya-3";
export var errorCard = "_ya-4";
export var row = "_ya-1";